import { supabase } from '../lib/supabase'

export interface Avviso {
  id: number
  tipo: 'informativo' | 'operativo'
  titolo: string
  corpo: string
}

/** Un avviso che non si carica non deve impedire di lavorare: si degrada a elenco vuoto. */
export async function avvisiAttivi(): Promise<Avviso[]> {
  const ora = new Date().toISOString()
  const { data, error } = await supabase
    .from('avviso')
    .select('id, tipo, titolo, corpo')
    .lte('valido_dal', ora)
    .or(`valido_al.is.null,valido_al.gte.${ora}`)
    .order('valido_dal', { ascending: false })

  if (error) return []
  return (data ?? []) as Avviso[]
}
